var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/utils/format.ts
var format_exports = {};
__export(format_exports, {
  completeUrlByDomain: () => completeUrlByDomain,
  formatDateTime: () => formatDateTime,
  humanizeSize: () => humanizeSize,
  resourceTypeKeyArrToResourceType: () => resourceTypeKeyArrToResourceType
});
import dayjs from "dayjs";

// src/utils/domain.ts
var domain_exports = {};
__export(domain_exports, {
  IMAGE_ORIGIN: () => IMAGE_ORIGIN,
  STATIC_ORIGIN: () => STATIC_ORIGIN,
  completeUrlByDomain: () => completeUrlByDomain,
  getCurrentEnv: () => getCurrentEnv,
  getEnvSuffix: () => getEnvSuffix,
  getHostMatchedPublicSuffix: () => getHostMatchedPublicSuffix,
  getMicroAppName: () => getMicroAppName,
  isDevEnv: () => isDevEnv,
  isProdEnv: () => isProdEnv,
  isTestEnv: () => isTestEnv
});
var ENV_SUFFIX = {
  prod: ".freelog.cn",
  dev: ".devfreelog.com",
  test: ".testfreelog.com"
};
var STATIC_ORIGIN = "https://static.freelog.cn";
var IMAGE_ORIGIN = "https://image.freelog.cn";
function publicSuffixFromHostname(hostname) {
  const h = hostname.toLowerCase();
  const m = h.match(/^(?:.*\.)?(testfreelog\.com|devfreelog\.com|freelog\.cn)$/);
  if (!m) {
    return ENV_SUFFIX.test;
  }
  return `.${m[1]}`;
}
function envFromPublicSuffix(suffix) {
  if (suffix === ENV_SUFFIX.prod) return "prod";
  if (suffix === ENV_SUFFIX.dev) return "dev";
  return "test";
}
function getHostMatchedPublicSuffix() {
  if (typeof window === "undefined") {
    return ENV_SUFFIX.test;
  }
  return publicSuffixFromHostname(window.location.hostname);
}
function getCurrentEnv() {
  if (typeof window === "undefined") {
    return "test";
  }
  return envFromPublicSuffix(publicSuffixFromHostname(window.location.hostname));
}
function isProdEnv() {
  return getCurrentEnv() === "prod";
}
function isDevEnv() {
  return getCurrentEnv() === "dev";
}
function isTestEnv() {
  return getCurrentEnv() === "test";
}
function getEnvSuffix(env) {
  if (env !== void 0) {
    return ENV_SUFFIX[env];
  }
  return getHostMatchedPublicSuffix();
}
function completeUrlByDomain(domain) {
  if (domain === "image") return IMAGE_ORIGIN;
  if (domain === "static") return STATIC_ORIGIN;
  const suffix = typeof window !== "undefined" ? publicSuffixFromHostname(window.location.hostname) : ENV_SUFFIX.test;
  return `https://${domain}${suffix}`;
}
function getMicroAppName(baseName) {
  if (isTestEnv()) return `${baseName}_test`;
  if (isDevEnv()) return `${baseName}_dev`;
  return baseName;
}

// src/utils/format.ts
function humanizeSize(bytes) {
  if (bytes <= 0) {
    return "0 B";
  }
  const unitArr = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const index = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = Math.round(bytes / Math.pow(1024, index) * 100) / 100;
  return size + " " + unitArr[index];
}
function formatDateTime(date, showTime = false) {
  return dayjs(date).format("YYYY/MM/DD" + (showTime ? " HH:mm" : ""));
}
function resourceTypeKeyArrToResourceType(arr) {
  return arr.join(" / ");
}

// src/utils/regexp.ts
var regexp_exports = {};
__export(regexp_exports, {
  BUCKET_NAME: () => BUCKET_NAME,
  CUSTOM_KEY: () => CUSTOM_KEY,
  DATE: () => DATE,
  DATE_TIME: () => DATE_TIME,
  EMAIL_ADDRESS: () => EMAIL_ADDRESS,
  EXHIBIT_NAME: () => EXHIBIT_NAME,
  JS_VARIABLE_NAME: () => JS_VARIABLE_NAME,
  MAX_2_DECIMAL_POSITIVE_NUMBER: () => MAX_2_DECIMAL_POSITIVE_NUMBER,
  MOBILE_PHONE_NUMBER: () => MOBILE_PHONE_NUMBER,
  NATURAL_NUMBER: () => NATURAL_NUMBER,
  NODE_DOMAIN: () => NODE_DOMAIN,
  NODE_NAME: () => NODE_NAME,
  PASSWORD: () => PASSWORD,
  PAY_PASSWORD: () => PAY_PASSWORD,
  POSITIVE_INTEGER: () => POSITIVE_INTEGER,
  RESOURCE_NAME: () => RESOURCE_NAME,
  RESOURCE_TYPE: () => RESOURCE_TYPE,
  USERNAME: () => USERNAME
});
var EXHIBIT_NAME = new RegExp(/^(?!.*(\\|\/|:|\*|\?|"|<|>|\||\s|@|\$|#)).{1,60}$/);
var RESOURCE_NAME = new RegExp(/^(?!.*(\\|\/|:|\*|\?|"|<|>|\||\s|@|\$|#)).{1,60}$/);
var RESOURCE_TYPE = new RegExp("^[\u4E00-\u9FEFa-zA-Z0-9\\-&.,]{1,40}$");
var CUSTOM_KEY = new RegExp("^[a-zA-Z]([a-zA-Z0-9_]{1,29})?$");
var NODE_NAME = new RegExp(/^[\u4E00-\u9FA5|a-zA-Z0-9]{2,24}$/);
var NODE_DOMAIN = new RegExp(/^[a-z0-9][a-z0-9-]{2,22}[a-z0-9]$/);
var PAY_PASSWORD = new RegExp(/^\d{6}$/);
var MOBILE_PHONE_NUMBER = new RegExp(/^1[345789]\d{9}$/);
var EMAIL_ADDRESS = new RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/);
var USERNAME = new RegExp(/^([A-Za-z0-9][A-Za-z0-9-]{0,28})?[A-Za-z0-9]$/);
var PASSWORD = new RegExp(/^(?=.*[0-9])(?=.*[a-zA-Z])(.{6,24})$/);
var NATURAL_NUMBER = new RegExp(/^[0-9]*$/);
var POSITIVE_INTEGER = new RegExp(/^[1-9]\d*$/);
var MAX_2_DECIMAL_POSITIVE_NUMBER = new RegExp(/^\d+(\.\d{0,2})?$/);
var BUCKET_NAME = new RegExp(/^([a-z0-9][a-z0-9-]{0,61})?[a-z0-9]$/);
var JS_VARIABLE_NAME = new RegExp(/^[A-Za-z$_][\w$_]*$/);
var DATE = new RegExp(/(([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)-(0[1-9]|[12][0-9]|30))|(02-(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))-02-29)$/);
var DATE_TIME = new RegExp(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/);

// src/utils/linkTo.ts
var linkTo_exports = {};
__export(linkTo_exports, {
  activities: () => activities,
  activity: () => activity,
  bind: () => bind,
  binding: () => binding,
  collectionContract: () => collectionContract,
  collectionCreateSuccess: () => collectionCreateSuccess,
  collectionCreator: () => collectionCreator,
  collectionDependency: () => collectionDependency,
  collectionDetails: () => collectionDetails,
  collectionExhibitCreator: () => collectionExhibitCreator,
  collectionExhibitManagement: () => collectionExhibitManagement,
  collectionInfo: () => collectionInfo,
  collectionPolicy: () => collectionPolicy,
  collectionVersionInfo: () => collectionVersionInfo,
  contract: () => contract,
  createdCollectionExhibitManagement: () => createdCollectionExhibitManagement,
  dashboard: () => dashboard,
  exampleNodes: () => exampleNodes,
  exception403: () => exception403,
  exceptionCommon: () => exceptionCommon,
  exceptionUnableToAccess: () => exceptionUnableToAccess,
  exhibitManagement: () => exhibitManagement,
  globalSearch: () => globalSearch,
  home: () => home,
  informExhibitManagement: () => informExhibitManagement,
  informNodeManagement: () => informNodeManagement,
  invitation: () => invitation,
  login: () => login,
  logon: () => logon,
  market: () => market,
  myCollections: () => myCollections,
  myCollects: () => myCollects,
  myResourceIncome: () => myResourceIncome,
  myResourceTransaction: () => myResourceTransaction,
  myResources: () => myResources,
  nodeCreateSuccess: () => nodeCreateSuccess,
  nodeCreator: () => nodeCreator,
  nodeDeleted: () => nodeDeleted,
  nodeFreeze: () => nodeFreeze,
  nodeManagement: () => nodeManagement,
  objectDetails: () => objectDetails,
  resourceContract: () => resourceContract,
  resourceCreateSuccess: () => resourceCreateSuccess,
  resourceCreator: () => resourceCreator,
  resourceCreatorBatch: () => resourceCreatorBatch,
  resourceCreatorEntry: () => resourceCreatorEntry,
  resourceDependency: () => resourceDependency,
  resourceDetails: () => resourceDetails,
  resourceFreeze: () => resourceFreeze,
  resourceInfo: () => resourceInfo,
  resourcePolicy: () => resourcePolicy,
  resourceVersionCreateRelease: () => resourceVersionCreateRelease,
  resourceVersionCreateSuccess: () => resourceVersionCreateSuccess,
  resourceVersionCreator: () => resourceVersionCreator,
  resourceVersionInfo: () => resourceVersionInfo,
  resultBindingSuccess: () => resultBindingSuccess,
  retrievePayPassword: () => retrievePayPassword,
  retrieveUserPassword: () => retrieveUserPassword,
  reward: () => reward,
  setting: () => setting,
  settlementBankCardEditor: () => settlementBankCardEditor,
  settlementInfo: () => settlementInfo,
  settlementInfoCreator: () => settlementInfoCreator,
  settlementInfoEditor: () => settlementInfoEditor,
  storageSpace: () => storageSpace,
  userFreeze: () => userFreeze,
  wallet: () => wallet,
  wxShare: () => wxShare
});
import * as querystring from "querystring";
function home({} = {}) {
  return `/home`;
}
function activities({} = {}) {
  return `/activities`;
}
function activity({ activityID }) {
  return `/activity/${activityID}`;
}
function wxShare({ link, title, desc, imgUrl }) {
  return `/wx-share/index.html#title=${title}&desc=${desc}&link=${link}&imgUrl=${imgUrl}`;
}
function dashboard({} = {}) {
  return `/dashboard`;
}
function market({ ...params } = {}) {
  return `/market${handleQuery(params)}`;
}
function exampleNodes({} = {}) {
  return `/examples`;
}
function resourceDetails({
  resourceID,
  ...params
}) {
  return `/resource/details/${resourceID}${handleQuery(params)}`;
}
function collectionDetails({
  collectionID
}) {
  return `/resource/collectionDetails/${collectionID}`;
}
function resourceCreatorEntry({} = {}) {
  return `/resource/creatorEntry`;
}
function resourceCreator({} = {}) {
  return `/resource/creator`;
}
function resourceCreatorBatch({} = {}) {
  return `/resource/creatorBatch`;
}
function collectionCreator({} = {}) {
  return `/resource/collectionCreator`;
}
function myResources({} = {}) {
  return `/resource/list`;
}
function myCollections({} = {}) {
  return `/resource/collection`;
}
function myCollects({} = {}) {
  return `/resource/collect`;
}
function myResourceIncome({} = {}) {
  return `/resource/income`;
}
function myResourceTransaction({} = {}) {
  return `/resource/transaction`;
}
function resourceVersionInfo({
  resourceID,
  version = ""
}) {
  return `/resource/sidebar/versionInfo/${resourceID}${handleQuery({
    version
  })}`;
}
function resourceInfo({
  resourceID
}) {
  return `/resource/sidebar/info/${resourceID}`;
}
function resourcePolicy({
  resourceID
}) {
  return `/resource/sidebar/policy/${resourceID}`;
}
function resourceContract({
  resourceID
}) {
  return `/resource/sidebar/contract/${resourceID}`;
}
function resourceDependency({
  resourceID
}) {
  return `/resource/sidebar/dependency/${resourceID}`;
}
function resourceVersionCreator({
  resourceID
}) {
  return `/resource/versionCreator/${resourceID}`;
}
function collectionVersionInfo({
  collectionID
}) {
  return `/resource/collectionSidebar/versionInfo/${collectionID}`;
}
function collectionInfo({
  collectionID
}) {
  return `/resource/collectionSidebar/info/${collectionID}`;
}
function collectionPolicy({
  collectionID
}) {
  return `/resource/collectionSidebar/policy/${collectionID}`;
}
function collectionContract({
  collectionID
}) {
  return `/resource/collectionSidebar/contract/${collectionID}`;
}
function collectionDependency({
  collectionID
}) {
  return `/resource/collectionSidebar/dependency/${collectionID}`;
}
function nodeCreator({} = {}) {
  return `/node/creator`;
}
function nodeManagement({
  nodeID,
  showPage = "exhibit",
  ...params
}) {
  return `/node/formal/${nodeID}${handleQuery({ showPage, ...params })}`;
}
function exhibitManagement({
  exhibitID,
  ...params
}) {
  return `/node/exhibit/formal/${exhibitID}${handleQuery({
    ...params
  })}`;
}
function collectionExhibitManagement({
  exhibitID,
  openAuthDrawer
}) {
  return `/node/collectionExhibit/formal/${exhibitID}${handleQuery({
    openAuthDrawer
  })}`;
}
function collectionExhibitCreator({
  nodeID
}) {
  return `/node/collectionExhibitCreator/${nodeID}`;
}
function createdCollectionExhibitManagement({
  exhibitID
}) {
  return `/node/createdCollectionExhibit/formal/${exhibitID}`;
}
function informNodeManagement({
  nodeID,
  showPage = "exhibit",
  ...params
}) {
  return `/node/informal/${nodeID}${handleQuery({ showPage, ...params })}`;
}
function informExhibitManagement({
  exhibitID,
  openAuthDrawer = void 0
}) {
  return `/node/exhibit/informal/${exhibitID}${handleQuery({
    openAuthDrawer
  })}`;
}
function storageSpace({
  ...params
} = {}) {
  return `/storage${handleQuery(params)}`;
}
function objectDetails({
  ...params
}) {
  return `/storage${handleQuery(params)}`;
}
function collectionCreateSuccess({
  collectionID
}) {
  return `/result/collection/create/success/${collectionID}`;
}
function resourceCreateSuccess({
  resourceID
}) {
  return `/result/resource/create/success/${resourceID}`;
}
function resourceVersionCreateSuccess({
  resourceID,
  version
}) {
  return `/result/resource/version/create/success/${resourceID}/${version}`;
}
function resourceVersionCreateRelease({
  resourceID,
  version
}) {
  return `/result/resource/version/create/release/${resourceID}/${version}`;
}
function nodeCreateSuccess({ nodeID }) {
  return `/result/node/create/success/${nodeID}`;
}
function invitation({ goTo, ...params } = {}) {
  return `/invitation${handleQuery({
    ...params,
    returnUrl: goTo ? encodeURIComponent(goTo) : void 0
  })}`;
}
function exception403({ ...params } = {}) {
  let fromUrl = params.from || "";
  if (!fromUrl) {
    const { href, origin } = window.location;
    fromUrl = href.replace(origin, "");
  }
  return `/exception/403${handleQuery({
    from: fromUrl
  })}`;
}
function exceptionUnableToAccess({
  ...params
} = {}) {
  let fromUrl = params.from || "";
  if (!fromUrl) {
    const { href, origin } = window.location;
    fromUrl = href.replace(origin, "");
  }
  return `/exception/unableToAccess${handleQuery({
    from: fromUrl
  })}`;
}
function exceptionCommon({ ...params } = {}) {
  return `/exception/common${handleQuery({
    ...params
  })}`;
}
function nodeFreeze({ nodeID }) {
  return `/result/node/freeze/${nodeID}`;
}
function nodeDeleted({ nodeID }) {
  return `/result/node/deleted/${nodeID}`;
}
function resourceFreeze({ resourceID }) {
  return `/result/resource/freeze/${resourceID}`;
}
function globalSearch({ search }) {
  return `/search${handleQuery({
    search
  })}`;
}
function settlementInfoCreator({ nodeID }) {
  return `/settlementCreator${handleQuery({ nodeID })}`;
}
function settlementInfo({ accountID }) {
  return `/settlementInfo/${accountID}`;
}
function settlementInfoEditor({ accountID }) {
  return `/settlementEditor/${accountID}`;
}
function settlementBankCardEditor({ accountID }) {
  return `/settlementBankCardEditor/${accountID}`;
}
function login({ goTo } = {}) {
  return `/login${handleQuery({
    goTo: goTo ? encodeURIComponent(goTo) : void 0
  })}`;
}
function logon({ goTo, ...params } = {}) {
  return `/logon${handleQuery({
    goTo: goTo ? encodeURIComponent(goTo) : void 0,
    ...params
  })}`;
}
function bind({ goTo, returnUrl, ...params } = {}) {
  return `/bind${handleQuery({
    goTo: goTo ? encodeURIComponent(goTo) : void 0,
    returnUrl: returnUrl ? encodeURIComponent(returnUrl) : void 0,
    ...params
  })}`;
}
function retrieveUserPassword({
  goTo
} = {}) {
  return `/retrieve${handleQuery({
    goTo: goTo ? encodeURIComponent(goTo) : void 0
  })}`;
}
function retrievePayPassword({} = {}) {
  return `/retrievePayPassword`;
}
function userFreeze({} = {}) {
  return `/freeze`;
}
function wallet({} = {}) {
  return `/logged/wallet`;
}
function reward({} = {}) {
  return `/logged/reward`;
}
function contract({ ...params } = {}) {
  return `/logged/contract${handleQuery({
    ...params
  })}`;
}
function setting({} = {}) {
  return `/logged/setting`;
}
function binding({} = {}) {
  return `/logged/binding`;
}
function resultBindingSuccess({} = {}) {
  return `/result/binding`;
}
function handleQuery(query) {
  const obj = {};
  for (const [key, value] of Object.entries(query)) {
    if (key && value) {
      obj[key] = value;
    }
  }
  const result = querystring.stringify(obj);
  return result ? "?" + result : "";
}

// src/utils/predefined.ts
var predefined_exports = {};
__export(predefined_exports, {
  EnumContractPartyIdentityType: () => EnumContractPartyIdentityType,
  EnumContractStatus: () => EnumContractStatus,
  EnumSubjectType: () => EnumSubjectType,
  momentDateFormat: () => momentDateFormat,
  momentDateTimeFormat: () => momentDateTimeFormat,
  pageSize: () => pageSize,
  resourceTypes: () => resourceTypes
});
var resourceTypes = ["json", "widget", "image", "audio", "markdown", "theme", "reveal_slide", "license", "video", "catalog"];
var pageSize = 100;
var momentDateFormat = "YYYY-MM-DD";
var momentDateTimeFormat = "YYYY-MM-DD HH:mm";
var EnumContractPartyIdentityType = /* @__PURE__ */ ((EnumContractPartyIdentityType2) => {
  EnumContractPartyIdentityType2[EnumContractPartyIdentityType2["resource"] = 1] = "resource";
  EnumContractPartyIdentityType2[EnumContractPartyIdentityType2["node"] = 2] = "node";
  EnumContractPartyIdentityType2[EnumContractPartyIdentityType2["consumer"] = 3] = "consumer";
  return EnumContractPartyIdentityType2;
})(EnumContractPartyIdentityType || {});
var EnumSubjectType = /* @__PURE__ */ ((EnumSubjectType2) => {
  EnumSubjectType2[EnumSubjectType2["resource"] = 1] = "resource";
  EnumSubjectType2[EnumSubjectType2["exhibit"] = 2] = "exhibit";
  EnumSubjectType2[EnumSubjectType2["user"] = 3] = "user";
  return EnumSubjectType2;
})(EnumSubjectType || {});
var EnumContractStatus = /* @__PURE__ */ ((EnumContractStatus2) => {
  EnumContractStatus2[EnumContractStatus2["pending"] = 0] = "pending";
  EnumContractStatus2[EnumContractStatus2["authorized"] = 1] = "authorized";
  EnumContractStatus2[EnumContractStatus2["stopped"] = 2] = "stopped";
  return EnumContractStatus2;
})(EnumContractStatus || {});

// src/utils/axios.ts
import axios from "axios";

// src/service-API/nodes.ts
var nodes_exports = {};
__export(nodes_exports, {
  create: () => create,
  deleteNode: () => deleteNode,
  details: () => details,
  nodes: () => nodes,
  searchForClient: () => searchForClient,
  setNodeInfo: () => setNodeInfo
});
function create(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/nodes`,
    data: params
  });
}
function details(params) {
  if (params.nodeId) {
    return utils_default.Request({
      method: "GET",
      url: `/v2/nodes/${params.nodeId}`
      // params: params,
    });
  }
  return utils_default.Request({
    method: "GET",
    url: `/v2/nodes/detail`,
    params
  });
}
function nodes(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/nodes`,
    params
  });
}
function searchForClient(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/nodes/searchForClient`,
    params
  });
}
function setNodeInfo(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/nodes/setNodeInfo`,
    data: params
  });
}
function deleteNode({ nodeId }) {
  return utils_default.Request({
    method: "DELETE",
    url: `/v2/nodes/${nodeId}`
    // params: params,
  });
}

// src/service-API/presentables.ts
var presentables_exports = {};
__export(presentables_exports, {
  addItemsToPresentableCollection: () => addItemsToPresentableCollection,
  authTree: () => authTree,
  batchAuth: () => batchAuth,
  batchCreatePresentable: () => batchCreatePresentable,
  batchUpdatePresentable: () => batchUpdatePresentable,
  batchUpdatePresentableStatus: () => batchUpdatePresentableStatus,
  contractAppliedPresentable: () => contractAppliedPresentable,
  createPresentable: () => createPresentable,
  createPresentableCollection: () => createPresentableCollection,
  dependencyTree: () => dependencyTree,
  getItemsAutoCollectRule: () => getItemsAutoCollectRule,
  getItemsFromPresentableCollection: () => getItemsFromPresentableCollection,
  getItemsFromPresentableCollectionIsExist: () => getItemsFromPresentableCollectionIsExist,
  getItemsFromPresentableCollections: () => getItemsFromPresentableCollections,
  ignorePresentableVersionUpdateTip: () => ignorePresentableVersionUpdateTip,
  presentableDetails: () => presentableDetails,
  presentableList: () => presentableList,
  presentables: () => presentables,
  presentablesOnlineStatus: () => presentablesOnlineStatus,
  presentablesVersion: () => presentablesVersion,
  relationTree: () => relationTree,
  removeItemsFromPresentableCollection: () => removeItemsFromPresentableCollection,
  setItemsAutoCollectRule: () => setItemsAutoCollectRule,
  setItemsSortFromPresentableCollectionManual: () => setItemsSortFromPresentableCollectionManual,
  setItemsSortFromPresentableCollectionQuick: () => setItemsSortFromPresentableCollectionQuick,
  updatePresentable: () => updatePresentable,
  updatePresentableCollection: () => updatePresentableCollection,
  updatePresentableDependencyRewriteProperty: () => updatePresentableDependencyRewriteProperty,
  updateRewriteProperty: () => updateRewriteProperty
});
function createPresentable(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/presentables`,
    data: params
  });
}
function updatePresentable({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/presentables/${presentableId}`,
    data: params
  });
}
function presentablesOnlineStatus({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/presentables/${presentableId}/onlineStatus`,
    data: params
  });
}
function presentableDetails(params) {
  if (params.nodeId) {
    return utils_default.Request({
      method: "GET",
      url: `/v2/presentables/detail`,
      params
    });
  }
  const { presentableId, ...p } = params;
  return utils_default.Request({
    method: "GET",
    url: `/v2/presentables/${presentableId}`,
    params: p
  });
}
function presentables(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/presentables`,
    params
  });
}
function presentableList(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/presentables/list`,
    params
  });
}
function dependencyTree({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/presentables/${presentableId}/dependencyTree`,
    params
  });
}
function relationTree({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/presentables/${presentableId}/relationTree`,
    params
  });
}
function authTree({ presentableId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/presentables/${presentableId}/authTree`,
    params
  });
}
function presentablesVersion({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/presentables/${presentableId}/version`,
    data: params
  });
}
function updateRewriteProperty({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/presentables/${presentableId}/rewriteProperty`,
    data: params
  });
}
function updatePresentableDependencyRewriteProperty({
  presentableId,
  nid,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/presentables/${presentableId}/${nid}/dependencyRewriteProperty`,
    data: params
  });
}
function batchAuth({ nodeId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/auths/presentables/nodes/${nodeId}/batchAuth/result`,
    params
  });
}
function contractAppliedPresentable({
  nodeId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/presentables/${nodeId}/contractAppliedPresentable`,
    params
  });
}
function batchCreatePresentable(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/presentables/createPresentableBatchEasy`,
    data: params
  });
}
function batchUpdatePresentable({
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/presentables/updatePresentableBatch`,
    data: params
  });
}
function batchUpdatePresentableStatus({
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/presentables/updatePresentableOnlineStatusBatch`,
    data: params
  });
}
function ignorePresentableVersionUpdateTip({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/presentables/${presentableId}/ignorePresentableVersionUpdateTip`,
    data: params
  });
}
function createPresentableCollection({
  ...params
}) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/presentables/catalogues`,
    data: params
  });
}
function updatePresentableCollection({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/presentables/catalogues/${presentableId}`,
    data: params
  });
}
function addItemsToPresentableCollection({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/presentables/catalogues/${presentableId}/items`,
    data: params
  });
}
function removeItemsFromPresentableCollection({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "DELETE",
    url: `/v2/presentables/catalogues/${presentableId}/items`,
    params
  });
}
function getItemsFromPresentableCollection({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/presentables/catalogues/${presentableId}/items`,
    params
  });
}
function getItemsFromPresentableCollectionIsExist({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/presentables/catalogues/${presentableId}/items/checkExists`,
    params
  });
}
function setItemsSortFromPresentableCollectionManual({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/presentables/catalogues/${presentableId}/manualSort`,
    data: params
  });
}
function setItemsSortFromPresentableCollectionQuick({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/presentables/catalogues/${presentableId}/reorder`,
    data: params
  });
}
function getItemsAutoCollectRule({
  presentableId
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/presentables/catalogues/${presentableId}/items/collectRules`
    // params: params,
  });
}
function setItemsAutoCollectRule({
  presentableId,
  ...params
}) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/presentables/catalogues/${presentableId}/items/collectRules`,
    data: params
  });
}
function getItemsFromPresentableCollections({
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    // url: `/v2/presentables/catalogues/items/batch/list?presentableIds=685cf423e1502e002fe3053b&limit=1&sortType=-1&sortField=createDate`,
    url: `/v2/presentables/catalogues/items/batch/list`,
    params
  });
}

// src/service-API/storages.ts
var storages_exports = {};
__export(storages_exports, {
  batchObjectList: () => batchObjectList,
  batchUpdateObject: () => batchUpdateObject,
  bucketDetails: () => bucketDetails,
  bucketIsExist: () => bucketIsExist,
  bucketList: () => bucketList,
  clearUserNodeData: () => clearUserNodeData,
  createBucket: () => createBucket,
  createObject: () => createObject,
  cycleDependencyCheck: () => cycleDependencyCheck,
  deleteBucket: () => deleteBucket,
  deleteObjects: () => deleteObjects,
  downloadObject: () => downloadObject,
  fileIsExist: () => fileIsExist,
  fileProperty: () => fileProperty,
  filesInfo: () => filesInfo,
  filesListInfo: () => filesListInfo,
  generateCoverImage: () => generateCoverImage,
  handleImage: () => handleImage,
  objectDetails: () => objectDetails2,
  objectList: () => objectList,
  spaceStatistics: () => spaceStatistics,
  updateObject: () => updateObject,
  uploadFile: () => uploadFile,
  uploadImage: () => uploadImage,
  userNodeDataList: () => userNodeDataList
});
function createBucket(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/storages/buckets`,
    data: params
  });
}
function bucketList(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/storages/buckets`,
    params
  });
}
function spaceStatistics(params = {}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/storages/buckets/spaceStatistics`,
    params
  });
}
function deleteBucket(params) {
  return utils_default.Request({
    method: "DELETE",
    url: `/v2/storages/buckets/${params.bucketName}`
    // params: params,
  });
}
function bucketDetails({ bucketName }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/storages/buckets/${bucketName}`
    // params: params,
  });
}
function objectList({ bucketName, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/storages/buckets/${bucketName}/objects`,
    params
  });
}
function userNodeDataList(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/storages/buckets/.UserNodeData/objects`,
    params
  });
}
function createObject({ bucketName, ...params }) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/storages/buckets/${bucketName}/objects`,
    data: params
  });
}
function objectDetails2(params) {
  if (params.objectIdOrName) {
    return utils_default.Request({
      method: "GET",
      url: `/v2/storages/objects/${encodeURIComponent(params.objectIdOrName)}`,
      params
    });
  }
  return utils_default.Request({
    method: "GET",
    url: `/v2/storages/buckets/${params.bucketName}/objects/${params.objectId}`,
    params
  });
}
function deleteObjects(params) {
  return utils_default.Request({
    method: "DELETE",
    url: `/v2/storages/buckets/${params.bucketName}/objects/${params.objectIds}`
    // data: params,
  });
}
function bucketIsExist({ bucketName }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/storages/buckets/${bucketName}/isExist`
    // params: params,
  });
}
function downloadObject(params) {
  return window.location.href = utils_default.Format.completeUrlByDomain("api") + `/v2/storages/objects/${params.objectIdOrName}/file`;
}
function fileIsExist(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/storages/files/fileIsExist`,
    params
  });
}
function uploadFile(params, config, returnCancel = false) {
  const formData = new FormData();
  for (const [key, value] of Object.entries(params)) {
    if (value) {
      formData.append(key, value);
    }
  }
  if (!returnCancel) {
    return utils_default.Request({
      method: "POST",
      url: `/v2/storages/files/upload`,
      data: formData,
      ...config
    });
  }
  let cancel = null;
  const promise = utils_default.Request({
    method: "POST",
    url: `/v2/storages/files/upload`,
    data: formData,
    cancelToken: new utils_default.Axios.CancelToken((c) => {
      cancel = c;
    }),
    ...config
  });
  return [
    promise,
    cancel
  ];
}
function uploadImage(params, config) {
  const formData = new FormData();
  for (const [key, value] of Object.entries(params)) {
    if (value) {
      formData.append(key, value);
    }
  }
  return utils_default.Request({
    method: "POST",
    url: `/v2/storages/files/uploadImage`,
    data: formData,
    ...config
  });
}
function handleImage(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/storages/files/imageHandle`,
    data: params
  });
}
function generateCoverImage(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/storages/files/generateCoverImage`,
    data: params
  });
}
function updateObject({ objectIdOrName, ...params }) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/storages/objects/${objectIdOrName}`,
    data: params
  });
}
function batchUpdateObject({ ...params }) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/storages/objects/updateBatch`,
    data: params
  });
}
function batchObjectList(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/storages/objects/list`,
    params
  });
}
function fileProperty({ sha1, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/storages/files/${sha1}/property`,
    params
  });
}
function cycleDependencyCheck({ objectIdOrName, ...params }) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/storages/objects/${objectIdOrName}/cycleDependencyCheck`,
    data: params
  });
}
function clearUserNodeData({ ...params }) {
  return utils_default.Request({
    method: "DELETE",
    url: `/v2/storages/buckets/.UserNodeData/objects/clear`,
    data: params
  });
}
function filesListInfo({ ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/storages/files/list/info`,
    params
  });
}
function filesInfo({ ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/storages/files/info`,
    params
  });
}

// src/service-API/collections.ts
var collections_exports = {};
__export(collections_exports, {
  collectResource: () => collectResource,
  collectedCount: () => collectedCount,
  collectionResources: () => collectionResources,
  deleteCollectResource: () => deleteCollectResource,
  isCollected: () => isCollected
});
function collectResource(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/collections/resources`,
    data: params
  });
}
function collectionResources(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/collections/resources`,
    params
  });
}
function deleteCollectResource({ resourceId }) {
  return utils_default.Request({
    method: "DELETE",
    url: `/v2/collections/resources/${resourceId}`
    // params: params,
  });
}
function isCollected(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/collections/resources/isCollected`,
    params
  });
}
function collectedCount({ resourceId }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/collections/resources/${resourceId}/count`
    // params: params,
  });
}

// src/service-API/resources.ts
var resources_exports = {};
__export(resources_exports, {
  ListSimpleByParentCode: () => ListSimpleByParentCode,
  addResourceItems_Draft: () => addResourceItems_Draft,
  authTree: () => authTree2,
  availableTags: () => availableTags,
  batchAuth: () => batchAuth2,
  batchGetCoverageVersions: () => batchGetCoverageVersions,
  batchInfo: () => batchInfo,
  batchResourceItems: () => batchResourceItems,
  batchResourceItems_Draft: () => batchResourceItems_Draft,
  batchSetContracts: () => batchSetContracts,
  batchUpdate: () => batchUpdate,
  bindRssFeed: () => bindRssFeed,
  checkExistCollectionItems: () => checkExistCollectionItems,
  create: () => create2,
  createBatch: () => createBatch,
  createVersion: () => createVersion,
  cycleDependencyCheck: () => cycleDependencyCheck2,
  deleteCollectionItems_Draft: () => deleteCollectionItems_Draft,
  deleteCollectionUnitResource: () => deleteCollectionUnitResource,
  deleteResourceDraft: () => deleteResourceDraft,
  dependencyTree: () => dependencyTree2,
  generateResourceNames: () => generateResourceNames,
  getAttrsInfoByKey: () => getAttrsInfoByKey,
  getCollectionCollectRules: () => getCollectionCollectRules,
  getCollectionItems: () => getCollectionItems,
  getCollectionItemsAuth: () => getCollectionItemsAuth,
  getCollectionItemsAuth_Draft: () => getCollectionItemsAuth_Draft,
  getCollectionItems_Draft: () => getCollectionItems_Draft,
  getCollectionUpdateLogs: () => getCollectionUpdateLogs,
  getResourceAttrListSimple: () => getResourceAttrListSimple,
  getResourceBySha1: () => getResourceBySha1,
  getResourceTypeInfoByCode: () => getResourceTypeInfoByCode,
  getResourceVersionBySha1: () => getResourceVersionBySha1,
  getVersionList: () => getVersionList,
  getVersionListByResourceID: () => getVersionListByResourceID,
  info: () => info,
  list: () => list,
  listSimple4Recently: () => listSimple4Recently,
  lookDraft: () => lookDraft,
  relationTree: () => relationTree2,
  relationTreeAuth: () => relationTreeAuth,
  reorderCollectionItemsSort: () => reorderCollectionItemsSort,
  reorderCollectionItems_Draft: () => reorderCollectionItems_Draft,
  resolveResources: () => resolveResources,
  resourceIsExistInItems_Draft: () => resourceIsExistInItems_Draft,
  resourceIsUsedByOther: () => resourceIsUsedByOther,
  resourceTypes: () => resourceTypes2,
  resourceVersionInfo1: () => resourceVersionInfo1,
  resourceVersionInfo2: () => resourceVersionInfo2,
  resourcesCount: () => resourcesCount,
  resourcesDownload: () => resourcesDownload,
  resourcesRecommend: () => resourcesRecommend,
  saveVersionsDraft: () => saveVersionsDraft,
  setCollectRules: () => setCollectRules,
  setCollectionItemSort: () => setCollectionItemSort,
  setCollectionItemsSortID_Draft: () => setCollectionItemsSortID_Draft,
  setItemsTitle: () => setItemsTitle,
  update: () => update,
  updateCollection: () => updateCollection,
  updateCollectionItemAuthorization_Draft: () => updateCollectionItemAuthorization_Draft,
  updateCollectionItemsInfo_Draft: () => updateCollectionItemsInfo_Draft,
  updateResourceVersionInfo: () => updateResourceVersionInfo
});
function create2(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/resources`,
    data: params
  });
}
function createBatch(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/resources/createBatch`,
    data: params
  });
}
function update(params) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/resources/${params.resourceId}`,
    data: params
  });
}
function batchUpdate(params) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/resources/updateBatch`,
    data: params
  });
}
function list(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources`,
    params
  });
}
function info({ resourceIdOrName, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/${encodeURIComponent(resourceIdOrName)}`,
    params
  });
}
function batchInfo(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/list`,
    params
  });
}
function dependencyTree2({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/${resourceId}/dependencyTree`,
    params
  });
}
function authTree2({ resourceId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/${resourceId}/authTree`,
    params
  });
}
function createVersion({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/resources/${resourceId}/versions`,
    data: params
  });
}
function resourceVersionInfo1({
  resourceId,
  version,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/${resourceId}/versions/${version}`,
    params
  });
}
function resourceVersionInfo2(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/versions/detail`,
    params
  });
}
function getVersionListByResourceID({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/${resourceId}/versions`,
    params
  });
}
function getVersionList({ ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/versions/list`,
    params
  });
}
function getResourceVersionBySha1({
  fileSha1,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/files/${fileSha1}/versions`,
    params
  });
}
function getResourceBySha1({
  fileSha1,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/files/${fileSha1}`,
    params
  });
}
function updateResourceVersionInfo(params) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/resources/${params.resourceId}/versions/${params.version}`,
    data: params
  });
}
function saveVersionsDraft(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/resources/${params.resourceId}/versions/drafts`,
    data: params
  });
}
function lookDraft(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/${params.resourceId}/versions/drafts`,
    params
  });
}
function deleteResourceDraft({
  resourceId
}) {
  return utils_default.Request({
    method: "DELETE",
    url: `/v2/resources/${resourceId}/versions/drafts`
    // data: params,
  });
}
function resourceIsUsedByOther(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/versions/isCanBeCreate`,
    params
  });
}
function resourcesDownload(params) {
  return window.location.href = utils_default.Format.completeUrlByDomain("api") + `/v2/resources/${params.resourceId}/versions/${params.version}/download`;
}
function batchGetCoverageVersions({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/${resourceId}/contracts/coverageVersions`,
    params
  });
}
function resolveResources(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/${params.resourceId}/resolveResources`
    // params: params,
  });
}
function batchSetContracts({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/resources/${resourceId}/versions/batchSetContracts`,
    data: params
  });
}
function cycleDependencyCheck2({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/resources/${resourceId}/versions/cycleDependencyCheck`,
    data: params
  });
}
function relationTree2({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/${resourceId}/relationTree`,
    params
  });
}
function relationTreeAuth({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/auths/resources/${resourceId}/relationTreeAuth`,
    params
  });
}
function resourcesCount({ ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/count`,
    params
  });
}
function batchAuth2({ ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/auths/resources/batchAuth/results`,
    params
  });
}
function resourcesRecommend({
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/recommend`,
    params
  });
}
function availableTags({ ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/tags/availableTags`,
    params
  });
}
function resourceTypes2({ ...params } = {}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/types/listSimpleByGroup`,
    params
  });
}
function ListSimpleByParentCode({
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/types/listSimpleByParentCode`,
    params
  });
}
function getResourceTypeInfoByCode({
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/types/getInfoByCode`,
    params
  });
}
function getResourceAttrListSimple({
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/attrs/listSimple`,
    params
  });
}
function listSimple4Recently({
  ...params
} = {}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/types/listSimple4Recently`,
    params
  });
}
function getAttrsInfoByKey({ ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/attrs/getInfoByKey`,
    params
  });
}
function generateResourceNames({
  resourceNames
}) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/resources/generateResourceNames`,
    data: {
      resourceNames
    }
  });
}
function updateCollection({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/resources/catalogue/${resourceId}`,
    data: params
  });
}
function deleteCollectionUnitResource({
  resourceId,
  removeCollectionItemIds
}) {
  return utils_default.Request({
    method: "DELETE",
    url: `/v2/resources/catalogue/${resourceId}?removeCollectionItemIds=${removeCollectionItemIds.join(
      ","
    )}`
    // data: params,
  });
}
function getCollectionItems({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/catalogue/${resourceId}/items`,
    params
  });
}
function getCollectionItems_Draft({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/catalogues/drafts/${resourceId}/items`,
    params
  });
}
function setCollectionItemSort({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/resources/catalogue/${resourceId}/manualSort`,
    data: params
  });
}
function reorderCollectionItemsSort({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/resources/catalogue/${resourceId}/reorder`,
    data: params
  });
}
function checkExistCollectionItems({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/catalogue/${resourceId}/items/checkExists`,
    params
  });
}
function getCollectionItemsAuth({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/auths/resources/${resourceId}/items/batchAuth`,
    params
  });
}
function batchResourceItems({
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/catalogue/items/batch/list`,
    params
  });
}
function batchResourceItems_Draft({
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/catalogues/drafts/items/batch/list`,
    params
  });
}
function getCollectionUpdateLogs({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/catalogue/${resourceId}/updateLogs`,
    params
  });
}
function getCollectionCollectRules({
  resourceId
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/catalogue/${resourceId}/items/collectRules`
    // params: params,
  });
}
function setCollectRules({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/resources/catalogue/${resourceId}/items/collectRules`,
    data: params
  });
}
function setItemsTitle({ resourceId, data }) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/resources/catalogue/${resourceId}/items`,
    data
  });
}
function deleteCollectionItems_Draft({
  resourceId,
  removeCollectionItemIds
}) {
  return utils_default.Request({
    method: "DELETE",
    url: `/v2/resources/catalogues/drafts/${resourceId}/items?removeCollectionItemIds=${removeCollectionItemIds.join(
      ","
    )}`
    // data: params,
  });
}
function setCollectionItemsSortID_Draft({
  resourceId,
  data
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/resources/catalogues/drafts/${resourceId}/manualSort`,
    data
  });
}
function reorderCollectionItems_Draft({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/resources/catalogues/drafts/${resourceId}/reorder`,
    data: params
  });
}
function resourceIsExistInItems_Draft({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/catalogues/drafts/${resourceId}/items/checkExists`,
    params
  });
}
function updateCollectionItemsInfo_Draft({
  resourceId,
  data
}) {
  return utils_default.Request({
    method: "PUT",
    // url: `/v2/resources/catalogue/${resourceId}/items`,
    url: `/v2/resources/catalogues/drafts/${resourceId}/items`,
    data
  });
}
function updateCollectionItemAuthorization_Draft({
  resourceId,
  itemId,
  ...data
}) {
  return utils_default.Request({
    method: "PUT",
    // url: `/v2/resources/catalogues/${resourceId}/items/${itemId}`,
    url: `/v2/resources/catalogues/drafts/${resourceId}/items/${itemId}`,
    data
  });
}
function addResourceItems_Draft({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/resources/catalogues/drafts/${resourceId}/items`,
    data: params
  });
}
function getCollectionItemsAuth_Draft({
  resourceId,
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/catalogues/drafts/${resourceId}/items/batchAuth`,
    params
  });
}
function bindRssFeed({ resourceId, ...params }) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/resources/rss/${resourceId}/bindFeed`,
    data: params
  });
}

// src/service-API/user.ts
var user_exports = {};
__export(user_exports, {
  areasProvinces: () => areasProvinces,
  batchUserList: () => batchUserList,
  currentUserInfo: () => currentUserInfo,
  getSignInfo: () => getSignInfo,
  login: () => login2,
  logon: () => logon2,
  logout: () => logout,
  registerOrBind: () => registerOrBind,
  resetPassword: () => resetPassword,
  searchForConsole: () => searchForConsole,
  signForCoins: () => signForCoins,
  thirdPartyIsBind: () => thirdPartyIsBind,
  thirdPartyList: () => thirdPartyList,
  thirdPartyUnbind: () => thirdPartyUnbind,
  updateDetailInfo: () => updateDetailInfo,
  updateMobileOrEmail: () => updateMobileOrEmail,
  updatePassword: () => updatePassword,
  uploadHeadImg: () => uploadHeadImg,
  userDetails: () => userDetails,
  users: () => users,
  verifyLoginPassword: () => verifyLoginPassword,
  wechatPublicApisShareSignature: () => wechatPublicApisShareSignature
});
function login2({ ...params }) {
  return utils_default.Request(
    {
      method: "POST",
      url: "/v2/passport/login",
      data: params
    },
    { noRedirect: true }
  );
}
function logout({ ...params } = {}) {
  return utils_default.Request(
    {
      method: "GET",
      url: "/v2/passport/logout",
      params
    },
    { noRedirect: true }
  );
}
function users(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/users/search`,
    params
  });
}
function batchUserList(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/users/list`,
    params
  });
}
function currentUserInfo({} = {}) {
  return utils_default.Request({
    method: "GET",
    url: "/v2/users/current"
    // params: params,
  });
}
function userDetails(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/users/detail`,
    params
  });
}
function logon2(params) {
  return utils_default.Request({
    method: "POST",
    url: "/v2/users",
    data: params
  });
}
function resetPassword({
  loginName,
  ...params
}) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/users/${loginName}/resetPassword`,
    data: params
  });
}
function updatePassword(params) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/users/current/updatePassword`,
    data: params
  });
}
function uploadHeadImg(params, config) {
  const formData = new FormData();
  for (const [key, value] of Object.entries(params)) {
    if (value) {
      formData.append(key, value);
    }
  }
  return utils_default.Request({
    method: "POST",
    url: `/v2/users/current/uploadHeadImg`,
    data: formData,
    ...config
  });
}
function updateDetailInfo(params) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/users/current/detailInfo`,
    data: params
  });
}
function verifyLoginPassword(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/users/verifyLoginPassword`,
    params
  });
}
function areasProvinces(params = {}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/areas/provinces`,
    params
  });
}
function updateMobileOrEmail(params) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/users/current/mobileOrEmail`,
    data: params
  });
}
function registerOrBind(params) {
  return utils_default.Request(
    {
      method: "POST",
      url: `/v2/thirdParty/registerOrBind`,
      data: params
    },
    { noRedirect: true }
  );
}
function thirdPartyUnbind(params) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/thirdParty/unbind`,
    data: params
  });
}
function thirdPartyList(params = {}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/thirdParty/list`,
    params
  });
}
function thirdPartyIsBind(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/thirdParty/isBind`,
    params
  });
}
function signForCoins() {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/facade/sign`
  });
}
function getSignInfo() {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/facade/signInfo`
  });
}
function searchForConsole(params = {}) {
  return utils_default.Request({
    method: "GET",
    url: "/v2/users/searchForConsole",
    params
  });
}
function wechatPublicApisShareSignature({
  ...params
}) {
  return utils_default.Request({
    method: "GET",
    url: "/v2/users/wechatPublicApis/shareSignature",
    params
  });
}

// src/service-API/informalNodes.ts
var informalNodes_exports = {};
__export(informalNodes_exports, {
  batchGetAuths: () => batchGetAuths,
  batchTestResources: () => batchTestResources,
  createRules: () => createRules,
  dependencyTree: () => dependencyTree3,
  dependencyTreeFilter: () => dependencyTreeFilter,
  putRules: () => putRules,
  rulesPreExecution: () => rulesPreExecution,
  rulesRematch: () => rulesRematch,
  searchTestResourcesByDependency: () => searchTestResourcesByDependency,
  testNodeRules: () => testNodeRules,
  testResourceDetails: () => testResourceDetails,
  testResources: () => testResources,
  testResourcesAuthTree: () => testResourcesAuthTree,
  testResourcesDependencyTree: () => testResourcesDependencyTree,
  updateTestResourceContracts: () => updateTestResourceContracts
});
function testResources({ nodeId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testNodes/${nodeId}/testResources`,
    params
  });
}
function createRules({ nodeId, ...params }) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/testNodes/${nodeId}/rules`,
    data: params
  });
}
function batchTestResources({ nodeId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testNodes/${nodeId}/testResources/list`,
    params
  });
}
function dependencyTree3({ nodeId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testNodes/${nodeId}/testResources/dependencyTree/search`,
    params
  });
}
function putRules({ nodeId, ...params }) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/testNodes/${nodeId}/rules`,
    data: params
  });
}
function testNodeRules({ nodeId }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testNodes/${nodeId}/rules`
    // params: params,
  });
}
function updateTestResourceContracts({ testResourceId, ...params }) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/testNodes/testResources/${testResourceId}`,
    data: params
  });
}
function dependencyTreeFilter({ testResourceId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testNodes/testResources/${testResourceId}/dependencyTree/filter`,
    params
  });
}
function testResourcesDependencyTree({ testResourceId }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testNodes/testResources/${testResourceId}/dependencyTree`
    // params: params,
  });
}
function testResourcesAuthTree({ testResourceId }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testNodes/testResources/${testResourceId}/authTree`
    // params: params,
  });
}
function testResourceDetails({ testResourceId }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testNodes/testResources/${testResourceId}`
    // params: params,
  });
}
function searchTestResourcesByDependency({ nodeId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testNodes/${nodeId}/testResources/searchByDependency`,
    params
  });
}
function rulesRematch({ nodeId, ...params }) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/testNodes/${nodeId}/rules/rematch`,
    data: params
  });
}
function rulesPreExecution({ nodeId, ...params }) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/testNodes/${nodeId}/rules/preExecution`,
    data: params
  });
}
function batchGetAuths({ nodeId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/auths/exhibits/${nodeId}/test/batchAuth/results`,
    params
  });
}

// src/service-API/contracts.ts
var contracts_exports = {};
__export(contracts_exports, {
  batchContracts: () => batchContracts,
  batchCreateContracts: () => batchCreateContracts,
  contractDetails: () => contractDetails,
  contracts: () => contracts,
  contractsSignCount: () => contractsSignCount,
  createContract: () => createContract,
  keywordSuggest: () => keywordSuggest,
  transitionRecords: () => transitionRecords
});
function createContract({ ...params }) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/contracts`,
    data: params
  });
}
function batchCreateContracts({ ...params }) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/contracts/batchSign`,
    data: params
  });
}
function contractDetails({ contractId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/contracts/${contractId}`,
    params
  });
}
function contracts(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/contracts`,
    params
  });
}
function keywordSuggest(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/contracts/keywordSuggest`,
    params
  });
}
function batchContracts(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/contracts/list`,
    params
  });
}
function transitionRecords({ contractId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/contracts/${contractId}/transitionRecords`,
    params
  });
}
function contractsSignCount(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/contracts/signCount`,
    params
  });
}

// src/service-API/transactions.ts
var transactions_exports = {};
__export(transactions_exports, {
  activateIndividualAccounts: () => activateIndividualAccounts,
  changePassword: () => changePassword,
  details: () => details2,
  individualAccounts: () => individualAccounts,
  resetPassword: () => resetPassword2,
  transactionDetails: () => transactionDetails,
  verifyTransactionPassword: () => verifyTransactionPassword
});
function details2({ accountId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/transactions/details/${accountId}`,
    params
  });
}
function individualAccounts({ userId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/accounts/individualAccounts/${userId}`,
    params
  });
}
function transactionDetails({ recordId }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/transactions/records/${recordId}`
    // params: params,
  });
}
function activateIndividualAccounts({ ...params }) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/accounts/individualAccounts/activate`,
    data: params
  });
}
function changePassword({ ...params }) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/accounts/individualAccounts`,
    data: params
  });
}
function resetPassword2({ ...params }) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/accounts/individualAccounts/resetPassword`,
    data: params
  });
}
function verifyTransactionPassword({ ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/accounts/individualAccounts/verifyTransactionPassword`,
    params
  });
}

// src/service-API/captcha.ts
var captcha_exports = {};
__export(captcha_exports, {
  sendVerificationCode: () => sendVerificationCode,
  verifyVerificationCode: () => verifyVerificationCode
});
function sendVerificationCode(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/messages/send`,
    data: params
  });
}
function verifyVerificationCode(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/messages/verify`,
    params
  });
}

// src/service-API/events.ts
var events_exports = {};
__export(events_exports, {
  transaction: () => transaction
});
function transaction({ contractId, ...params }) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/contracts/${contractId}/events/payment`,
    data: params
  });
}

// src/service-API/activities.ts
var activities_exports = {};
__export(activities_exports, {
  adsDetails: () => adsDetails,
  adsList: () => adsList,
  eventTrackingAdsClick: () => eventTrackingAdsClick,
  eventTrackingAdsVisit: () => eventTrackingAdsVisit,
  find4Client: () => find4Client,
  getBaseTaskInfo: () => getBaseTaskInfo,
  getCoinAccount: () => getCoinAccount,
  getCoinAccountRecords: () => getCoinAccountRecords,
  getLastTaskRecordDetail: () => getLastTaskRecordDetail,
  getMaterialsByUserIds: () => getMaterialsByUserIds,
  getNodeTaskInfo: () => getNodeTaskInfo,
  getResourceTaskInfo: () => getResourceTaskInfo,
  getRewardRecordInfo: () => getRewardRecordInfo,
  getRewardRecordInfos: () => getRewardRecordInfos,
  getTopicInfo: () => getTopicInfo,
  getWechatOfficialAccountInfo: () => getWechatOfficialAccountInfo,
  list4Client: () => list4Client,
  listInviteFriendInfos: () => listInviteFriendInfos,
  listRewardRecordInfos: () => listRewardRecordInfos,
  lotteryDraw: () => lotteryDraw,
  lotteryDrawResult: () => lotteryDrawResult,
  lotteryList: () => lotteryList,
  lotteryShow: () => lotteryShow,
  pushMessageTask: () => pushMessageTask,
  statisticRewardRecords: () => statisticRewardRecords,
  statisticSingleRewardRecordForAll: () => statisticSingleRewardRecordForAll,
  statisticTaskRecords: () => statisticTaskRecords,
  withdrawCoinAccount: () => withdrawCoinAccount
});
function list4Client(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/list4Client`,
    params
  });
}
function find4Client(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/find4Client`,
    params
  });
}
var ADS_LIST_PATH = "/v2/activities/ads/list4Client";
function adsList(params) {
  return utils_default.Request({
    method: "GET",
    url: ADS_LIST_PATH,
    params
  });
}
function adsDetails(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/ads/find4Client`,
    params
  });
}
function eventTrackingAdsVisit(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/ads/visit`,
    params
  });
}
function eventTrackingAdsClick(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/ads/click`,
    params
  });
}
function getBaseTaskInfo(params = {}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/facade/getBaseTaskInfo`,
    params
  });
}
function getResourceTaskInfo(params = {}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/facade/getResourceTaskInfo`,
    params
  });
}
function getNodeTaskInfo(params = {}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/facade/getNodeTaskInfo`,
    params
  });
}
function getLastTaskRecordDetail(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/facade/getLastTaskRecordDetail`,
    params
  });
}
function getRewardRecordInfo(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/facade/getRewardRecordInfo`,
    params
  });
}
function pushMessageTask(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/activities/facade/pushMessage4Task`,
    data: params
  });
}
function getCoinAccount(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/coin/account/find4Client`,
    params
  });
}
function withdrawCoinAccount(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/activities/coin/account/cash4Client`,
    data: params
  });
}
function getCoinAccountRecords(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/coin/record/list4Client`,
    params
  });
}
function getWechatOfficialAccountInfo(params = {}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/extensions/wechat/getRelationship4Client`,
    params
  });
}
function lotteryList(params = {}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/lottery/resource/list`,
    params
  });
}
function lotteryShow(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/lottery/resource/show`,
    params
  });
}
function listInviteFriendInfos(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/activities/facade/listInviteFriendInfos`,
    data: params
  });
}
function getRewardRecordInfos(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/activities/facade/getRewardRecordInfos`,
    data: params
  });
}
function listRewardRecordInfos(params = {}) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/activities/facade/listRewardRecordInfos`,
    data: params
  });
}
function statisticRewardRecords(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/activities/facade/statisticRewardRecords`,
    data: params
  });
}
function statisticTaskRecords(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/activities/facade/statisticTaskRecords`,
    data: params
  });
}
function statisticSingleRewardRecordForAll(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/activities/facade/statisticSingleRewardRecordForAll`,
    data: params
  });
}
function lotteryDraw(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/activities/lottery/capsule/draw`,
    data: params
  });
}
function lotteryDrawResult(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/activities/lottery/capsule/getInfo`,
    params
  });
}
function getTopicInfo(params) {
  return utils_default.Request({
    method: "GET",
    // url: `/v2/activities/item/getInfoByCode`,
    url: `/v2/activities/item/getInfoByCode4Client`,
    params
  });
}
function getMaterialsByUserIds(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/activities/lottery/capsule/listByUserIds`,
    data: params
  });
}

// src/service-API/testQualifications.ts
var testQualifications_exports = {};
__export(testQualifications_exports, {
  betaApply: () => betaApply,
  betaCodesActivate: () => betaCodesActivate,
  codeDetails1: () => codeDetails1,
  codeDetails2: () => codeDetails2,
  getBetaApply1: () => getBetaApply1,
  getBetaApply2: () => getBetaApply2,
  invitees: () => invitees,
  usedRecords: () => usedRecords
});
function codeDetails1({ code }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testQualifications/beta/codes/${code}`
    // data: params,
  });
}
function codeDetails2({}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testQualifications/beta/codes/userActivateCode`
    // data: params,
  });
}
function betaCodesActivate({ ...params }) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/testQualifications/beta/codes/activate`,
    data: params
  });
}
function usedRecords({ ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testQualifications/beta/codes/usedRecords`,
    params
  });
}
function betaApply({ ...params }) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/testQualifications/beta/apply`,
    data: params
  });
}
function getBetaApply1({ ...params } = {}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testQualifications/beta/apply/current`,
    params
  });
}
function getBetaApply2({ recordId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testQualifications/beta/apply/${recordId}`,
    params
  });
}
function invitees({ ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/testQualifications/beta/codes/invitees`,
    params
  });
}

// src/service-API/statistics.ts
var statistics_exports = {};
__export(statistics_exports, {
  transactionsCommon: () => transactionsCommon
});
function transactionsCommon(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/statistics/transactions/common`,
    params
  });
}

// src/service-API/i18n.ts
var i18n_exports = {};
__export(i18n_exports, {
  configsList: () => configsList
});
function configsList(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/i18n/configs/list`,
    data: params
  });
}

// src/service-API/policies.ts
var policies_exports = {};
__export(policies_exports, {
  policies: () => policies,
  policiesList: () => policiesList,
  policyReCompile: () => policyReCompile,
  policyTemplates: () => policyTemplates,
  policyTransferTranslation: () => policyTransferTranslation,
  policyTranslation: () => policyTranslation
});
function policies(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/policies`,
    params
  });
}
function policiesList(params) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/policies/list`,
    params
  });
}
function policyTemplates(params = {}) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/translate/cg/translate-config/list4Client`,
    data: params
  });
}
function toCgFillArgName(name) {
  const trimmed = String(name || "");
  if (!trimmed) {
    return trimmed;
  }
  return trimmed.startsWith("${") ? trimmed : `\${${trimmed}}`;
}
function policyReCompile(data) {
  const { contract: contract2, policyText, fillArgs, ...rest } = data;
  return utils_default.Request({
    method: "POST",
    url: `/v2/translate/cg/reCompile`,
    data: {
      ...rest,
      policyText: policyText ?? contract2,
      fillArgs: (fillArgs || []).map((arg) => ({
        ...arg,
        name: toCgFillArgName(arg.name)
      }))
    }
  });
}
function policyTranslation({
  contract: contract2,
  policyText,
  compileType
}) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/translate/cg/translate`,
    data: {
      policyText: policyText ?? contract2,
      compileType
    }
  });
}
function policyTransferTranslation(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/translate/transfer`,
    data: params
  });
}

// src/service-API/recombinations/index.ts
var recombinations_exports = {};
__export(recombinations_exports, {
  getFilesSha1Info: () => getFilesSha1Info
});

// src/utils/tools.ts
var tools_exports = {};
__export(tools_exports, {
  generateRandomCode: () => generateRandomCode,
  getAvatarUrl: () => getAvatarUrl,
  getSHA1Hash: () => getSHA1Hash,
  getUserIDByCookies: () => getUserIDByCookies,
  promiseSleep: () => promiseSleep,
  transformServerAPIContractState: () => transformServerAPIContractState
});
function getSHA1Hash(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = async () => {
      if (!reader.result) {
        resolve("");
        return "";
      }
      if (typeof reader.result === "string") {
        resolve("");
        return "";
      }
      const sha1 = await self.crypto.subtle.digest("SHA-1", reader.result).then((a) => Array.from(new Uint8Array(a)).map((a2) => a2.toString(16).padStart(2, "0")).join(""));
      resolve(sha1);
      return "";
    };
  });
}
function generateRandomCode(strLen = 5) {
  const allStr = "ABCDEFGHIJKLMNPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890";
  const newStrArr = [];
  for (let i = 0; i < strLen; i++) {
    newStrArr.push(allStr[Math.floor(Math.random() * 61)]);
  }
  return newStrArr.join("");
}
function getUserIDByCookies() {
  const uid = document.cookie.split("; ").find((co) => co.startsWith("uid="));
  if (!uid) {
    return -1;
  }
  return Number(uid.replace("uid=", ""));
}
function transformServerAPIContractState({
  status,
  authStatus
}) {
  if (status === 0) {
    if (authStatus === 1 || authStatus === 3) {
      return "active";
    }
    if (authStatus === 2) {
      return "testActive";
    }
    if (authStatus === 128) {
      return "inactive";
    }
  }
  if (status === 1) {
    return "terminal";
  }
  return "exception";
}
function promiseSleep(ms = 300) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}
function getAvatarUrl(userID = 0) {
  return `${completeUrlByDomain("image")}/avatar/${userID || getUserIDByCookies()}?t=${Date.now()}`;
}

// src/service-API/recombinations/index.ts
async function getFilesSha1Info({
  sha1,
  resourceTypeCode
}, cdPartially = () => void 0) {
  if (sha1.length === 0) {
    return {
      error: "",
      result: []
    };
  }
  let delay = 500;
  let needHandleSha1 = [...sha1];
  let allData = [];
  while (true) {
    const { ret, errCode, data, msg } = await filesListInfo({
      sha1: needHandleSha1.join(","),
      resourceTypeCode
    });
    if (ret !== 0 || errCode !== 0) {
      return {
        error: msg,
        result: allData
      };
    }
    needHandleSha1 = data.filter((d) => {
      return d.metaAnalyzeStatus === 0 || d.metaAnalyzeStatus === 1;
    }).map((d) => {
      return d.sha1;
    });
    const finishedInfo = data.filter((d) => {
      return d.metaAnalyzeStatus !== 0 && d.metaAnalyzeStatus !== 1;
    }).map((d) => {
      let state = "fail";
      if (!d.metaAnalyzeStatus) {
        state = "nonentity";
      } else if (d.metaAnalyzeStatus === 2) {
        state = "success";
      } else if (d.metaAnalyzeStatus === 3) {
        state = "fail";
      }
      return {
        sha1: d.sha1,
        state,
        info: d
      };
    });
    cdPartially && cdPartially(finishedInfo);
    allData = [
      ...allData,
      ...finishedInfo
    ];
    if (needHandleSha1.length === 0) {
      break;
    }
    await promiseSleep(delay);
  }
  return {
    error: "",
    result: allData
  };
}

// src/service-API/operation.ts
var operation_exports = {};
__export(operation_exports, {
  operationCategories: () => operationCategories,
  rankInfo: () => rankInfo,
  recordRank: () => recordRank
});
function operationCategories({ ...params } = {}) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/operation-categories/listSimpleByGroup`,
    params
  });
}
function recordRank({ ...params }) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/activities/coin/record/rank`,
    data: params
  });
}
function rankInfo({ ...params }) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/activities/coin/record/rankInfo`,
    data: params
  });
}

// src/service-API/resourceType.ts
var resourceType_exports = {};
__export(resourceType_exports, {
  getInfoByCode: () => getInfoByCode,
  getInfoByCodeOrName: () => getInfoByCodeOrName
});
function getInfoByCode({ ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/types/getInfoByCode`,
    params
  });
}
function getInfoByCodeOrName({ ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/resources/types/getInfoByCodeOrName`,
    params
  });
}

// src/service-API/payment.ts
var payment_exports = {};
__export(payment_exports, {
  bindWithdrawCard: () => bindWithdrawCard,
  openFinancialAccount: () => openFinancialAccount,
  queryBindWithdrawCard: () => queryBindWithdrawCard,
  queryFee: () => queryFee,
  queryFinancialAccountInfo: () => queryFinancialAccountInfo,
  queryFinancialAccountInfo2: () => queryFinancialAccountInfo2,
  queryStatistics: () => queryStatistics,
  queryTransactionList: () => queryTransactionList,
  queryWithdrawCashList: () => queryWithdrawCashList,
  queryWithdrawStatus: () => queryWithdrawStatus,
  updateFinancialAccount: () => updateFinancialAccount,
  uploadIDCard: () => uploadIDCard,
  withdrawCash: () => withdrawCash
});
function uploadIDCard(params, config) {
  const formData = new FormData();
  for (const [key, value] of Object.entries(params)) {
    if (value) {
      formData.append(key, value);
    }
  }
  return utils_default.Request({
    method: "POST",
    url: `/v3/transactions/accounts/idCardUploadAndOcr`,
    data: formData,
    ...config
  });
}
function openFinancialAccount(params, config) {
  return utils_default.Request({
    method: "POST",
    url: `/v3/transactions/accounts`,
    data: params,
    ...config
  });
}
function updateFinancialAccount({ accountId, ...params }, config) {
  return utils_default.Request({
    method: "PUT",
    url: `/v3/transactions/accounts/${accountId}`,
    data: params,
    ...config
  });
}
function bindWithdrawCard({ accountId, ...params }, config) {
  return utils_default.Request({
    method: "POST",
    url: `/v3/transactions/accounts/${accountId}/bindCashCard`,
    data: params,
    ...config
  });
}
function queryFinancialAccountInfo(params, config) {
  return utils_default.Request({
    method: "GET",
    url: `/v3/transactions/accounts/query`,
    params,
    ...config
  });
}
function queryFinancialAccountInfo2({ accountId }, config) {
  return utils_default.Request({
    method: "GET",
    url: `/v3/transactions/accounts/${accountId}`,
    // params: { accountId },
    ...config
  });
}
function queryBindWithdrawCard({ accountId }, config) {
  return utils_default.Request({
    method: "GET",
    url: `/v3/transactions/accounts/${accountId}/cashCard`,
    ...config
  });
}
function queryWithdrawStatus(params, config) {
  return utils_default.Request({
    method: "GET",
    url: `/v3/transactions/withdrawCash/check`,
    params,
    ...config
  });
}
function withdrawCash(params, config) {
  return utils_default.Request({
    method: "POST",
    url: `/v3/transactions/withdrawCash`,
    data: params,
    ...config
  });
}
function queryWithdrawCashList(params, config) {
  return utils_default.Request({
    method: "GET",
    url: `/v3/transactions/withdrawCash/records`,
    params,
    ...config
  });
}
function queryTransactionList(params, config) {
  return utils_default.Request({
    method: "GET",
    url: `/v3/transactions/records`,
    params,
    ...config
  });
}
function queryStatistics(params, config) {
  return utils_default.Request({
    method: "GET",
    url: `/v3/transactions/statistics`,
    params,
    ...config
  });
}
function queryFee(params, config) {
  return utils_default.Request({
    method: "GET",
    url: `/v3/transactions/withdrawCashFeeCalculate`,
    params,
    ...config
  });
}

// src/service-API/rss.ts
var rss_exports = {};
__export(rss_exports, {
  bindingsCompare: () => bindingsCompare,
  bindingsPreview: () => bindingsPreview,
  failedItems: () => failedItems,
  getSyncProgress: () => getSyncProgress,
  sendVerificationCode: () => sendVerificationCode2,
  syncBinding: () => syncBinding
});
function bindingsPreview(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/rss/bindings/preview`,
    data: params
  });
}
function bindingsCompare(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/rss/bindings/compare`,
    data: params
  });
}
function sendVerificationCode2(params) {
  return utils_default.Request({
    method: "POST",
    url: `/v2/rss/bindings/sendVerificationCode`,
    data: params
  });
}
function getSyncProgress({ resourceId }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/rss/bindings/${resourceId}/progress`
  });
}
function syncBinding({ resourceId }) {
  return utils_default.Request({
    method: "PUT",
    url: `/v2/rss/bindings/${resourceId}/sync`
  });
}
function failedItems({ resourceId, ...params }) {
  return utils_default.Request({
    method: "GET",
    url: `/v2/rss/bindings/${resourceId}/failedItems`,
    params
  });
}

// src/service-API/index.ts
var FServiceAPI = {
  Node: nodes_exports,
  Exhibit: presentables_exports,
  Storage: storages_exports,
  Collection: collections_exports,
  Resource: resources_exports,
  User: user_exports,
  InformalNode: informalNodes_exports,
  Contract: contracts_exports,
  Transaction: transactions_exports,
  Captcha: captcha_exports,
  Event: events_exports,
  Activity: activities_exports,
  TestQualification: testQualifications_exports,
  Statistic: statistics_exports,
  I18n: i18n_exports,
  Policy: policies_exports,
  recombination: recombinations_exports,
  Operation: operation_exports,
  ResourceType: resourceType_exports,
  Payment: payment_exports,
  Rss: rss_exports
};
var service_API_default = FServiceAPI;

// src/utils/axios.ts
axios.defaults.withCredentials = true;
axios.defaults.baseURL = completeUrlByDomain("api");
axios.interceptors.request.use((config) => {
  const url = config.url;
  if (typeof url === "string" && url.length > 0 && !/^https?:\/\//i.test(url) && !url.startsWith("//")) {
    config.baseURL = completeUrlByDomain("api");
  }
  return config;
});
axios.interceptors.response.use(
  (response) => {
    if (response.status !== 200 && response.status !== 201) {
      throw new Error(JSON.stringify({ status: response.status }));
    }
    if (response.headers["content-disposition"]?.includes("attachment;")) {
      return;
    }
    return response.data;
  },
  (error) => Promise.reject(error)
);
var axios_default = axios;
async function request(config, { noRedirect = false, noErrorAlert = false } = {}) {
  const result = await axios.request(config);
  if (result.errCode === 30 && !noRedirect) {
    await service_API_default.User.logout();
    window.location.replace(
      `${completeUrlByDomain("user")}${login({ goTo: window.location.href })}`
    );
  } else if (result.ret === 4 && result.errCode === 10 && !noRedirect) {
    window.location.replace(
      `${completeUrlByDomain("user")}${userFreeze({ goTo: window.location.href })}`
    );
  }
  return result;
}

// src/utils/hooks.ts
var hooks_exports = {};
__export(hooks_exports, {
  useGetState: () => useGetState
});
import * as React from "react";
function useGetState(initVal) {
  const [state, setState] = React.useState(initVal);
  const ref = React.useRef(initVal);
  function setStateCopy(newVal) {
    ref.current = newVal;
    setState(newVal);
  }
  function getState() {
    return ref.current;
  }
  return [state, setStateCopy, getState];
}

// src/utils/index.ts
var FUtil = {
  Format: format_exports,
  Regexp: regexp_exports,
  LinkTo: linkTo_exports,
  Predefined: predefined_exports,
  Axios: axios_default,
  Request: request,
  Tool: tools_exports,
  Hook: hooks_exports,
  Domain: domain_exports
  // i18n: new I18n(),
};
var utils_default = FUtil;

// src/i18n/I18nNext.ts
import i18next from "i18next";
import axios2 from "axios";
import Cookies from "js-cookie";
import htmlReactParser from "html-react-parser";
var ossJsonUrl = "https://freelog-i18n.oss-cn-shenzhen.aliyuncs.com/configs/i18n.json";
var ossJsonUrl_Test = "https://freelog-i18n.oss-cn-shenzhen.aliyuncs.com/configs-test/i18n.json";
var localStorage_i18nextLng_key = "locale";
var localStorage_i18nextResources_key = "i18nextResources";
var allLanguage = [
  { value: "en_US", label: "English" },
  { value: "zh_CN", label: "\u7B80\u4F53\u4E2D\u6587" }
];
var I18nNext = class {
  constructor() {
    this._loadingData = "NotStart";
    this._taskQueue = [];
    // private _currentLanguage: LanguageKeyType = window.localStorage.getItem(localStorage_i18nextLng_key) as null || 'zh_CN';
    this._currentLanguage = Cookies.get(localStorage_i18nextLng_key) || "zh_CN";
    const lng = this._currentLanguage;
    void i18next.init({
      lng,
      fallbackLng: "zh_CN",
      resources: {
        zh_CN: { translation: {} },
        en_US: { translation: {} }
      },
      interpolation: {
        escapeValue: false,
        prefix: "{",
        suffix: "}"
      }
    });
    this.ready();
    this.ready = this.ready.bind(this);
    this.t = this.t.bind(this);
    this.tAuto = this.tAuto.bind(this);
    this.changeLanguage = this.changeLanguage.bind(this);
    this.getAllLanguage = this.getAllLanguage.bind(this);
    this.getCurrentLanguage = this.getCurrentLanguage.bind(this);
  }
  async ready() {
    const exc = () => {
      while (this._taskQueue.length > 0) {
        const task = this._taskQueue.shift();
        task && task();
      }
    };
    const handleTasks = async () => {
      if (this._loadingData === "End") {
        exc();
        return;
      }
      if (this._loadingData === "Start") {
        return;
      }
      this._loadingData = "Start";
      await this._handleData();
      exc();
    };
    const promise = new Promise((resolve) => {
      this._taskQueue.push(resolve);
    });
    handleTasks();
    return promise;
  }
  t(key, options) {
    const k = key.trim();
    const out = i18next.t(k, options);
    return out == null ? k : String(out);
  }
  tJSXElement(key, options) {
    return htmlReactParser(i18next.t(key.trim(), options));
  }
  tAuto(key, options) {
    const k = key.trim();
    const raw = i18next.t(k, options);
    const i18n_str = raw == null ? k : String(raw);
    const trimmed = i18n_str.trim();
    if (!/^<div\s+class\s*=\s*["']i18n["']/i.test(trimmed)) {
      return i18n_str;
    }
    return htmlReactParser(trimmed);
  }
  changeLanguage(lng) {
    Cookies.set(localStorage_i18nextLng_key, lng, {
      expires: 36525,
      domain: utils_default.Format.completeUrlByDomain("").replace(/http(s)?:\/\//, "")
    });
  }
  getAllLanguage() {
    return allLanguage;
  }
  getCurrentLanguage() {
    return this._currentLanguage;
  }
  async _handleData() {
    const lng = this._currentLanguage;
    const resource = window.localStorage.getItem(localStorage_i18nextResources_key);
    let i18nextResources = resource ? JSON.parse(resource) : null;
    if (!i18nextResources) {
      i18nextResources = await this._fetchData();
    } else {
      this._fetchData();
    }
    await i18next.init({
      // the translations
      // (tip move them in a JSON file and import them,
      // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
      resources: i18nextResources,
      lng,
      // if you're using a language detector, do not define the lng option
      fallbackLng: "zh_CN",
      interpolation: {
        escapeValue: false,
        // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        prefix: "{",
        suffix: "}"
      }
    });
    this._loadingData = "End";
  }
  async _fetchData() {
    const url = window.location.origin.includes(".freelog.cn") ? ossJsonUrl : ossJsonUrl_Test;
    const res = await axios2.get(url + "?timestamp=" + Date.now(), {
      withCredentials: false
    });
    const en_US = {};
    const zh_CN = {};
    for (const [key, value] of Object.entries(res)) {
      en_US[key] = value["en_US"];
      zh_CN[key] = value["zh_CN"];
    }
    const result = {
      en_US: {
        translation: en_US
      },
      zh_CN: {
        translation: zh_CN
      }
    };
    window.localStorage.setItem(localStorage_i18nextResources_key, JSON.stringify(result));
    return result;
  }
};
var I18nNext_default = I18nNext;

// src/i18n/index.ts
var FI18n = {
  i18nNext: new I18nNext_default()
};
var i18n_default = FI18n;
export {
  i18n_default as FI18n,
  service_API_default as FServiceAPI,
  utils_default as FUtil
};
//# sourceMappingURL=index.mjs.map